import React from "react";

import {m} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {useOfferRankingListBreadcrumbs} from "../../hooks/use_offer_ranking_breadcrumbs";

export const OfferRankingBreadcrumbs = () => {
    const breadcrumbs = useOfferRankingListBreadcrumbs();

    return (
        <div css={m(2, 0)}>
            <Breadcrumbs homePageUrl={rpAppLink.base()} items={breadcrumbs} />
        </div>
    );
};
import React from "react";

import {m} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../../app/components/breadcrumbs/Breadcrumbs";
import {useOfferRankingListBreadcrumbs} from "../../hooks/use_offer_ranking_breadcrumbs";

export const OfferRankingBreadcrumbs = () => {
    const breadcrumbs = useOfferRankingListBreadcrumbs();

    return (
        <div css={m(2, 0)}>
            <Breadcrumbs homePageUrl={rpAppLink.base()} items={breadcrumbs} />
        </div>
    );
};
